import type { ApiClientConfig } from '@/api/client';

/**
 * Shared fetch wrapper used by screens that need to call endpoints not
 * yet in the OpenAPI specs (Phase 3 (2..N) deferred). It honors the
 * same baseUrl + bearer-token injection as the typed clients, so when
 * the real endpoints ship and the screen migrates to
 * `clients.<svc>.GET(...)` the auth behavior is identical.
 */
export async function apiFetch(
  config: ApiClientConfig,
  path: string,
  init?: RequestInit,
): Promise<Response> {
  const headers = new Headers(init?.headers);
  const token = config.getAuthToken?.();
  if (token && !headers.has('Authorization')) {
    headers.set('Authorization', `Bearer ${token}`);
  }
  return globalThis.fetch(`${config.baseUrl}${path}`, { ...init, headers });
}
